import { useEffect, useState } from 'react';
import { ReactComponent as Loading } from '../images/loading.svg';
import { ReactComponent as Star } from '../images/star.svg';

type Props = {
    boardSize: number,
    decodePuzzle: (puzzle: string) => Puzzle,
    loadPuzzle: (puzzle: Puzzle) => void
};
type Puzzle = {
    id: number,
    day: string,
    puzzle: number[],
    images: string[],
    score: number
};
type ResultRecord = {
    p: number,
    s: number
}

const Archive = ({ boardSize, decodePuzzle, loadPuzzle }: Props): JSX.Element => {
    const [data, setData] = useState<Array<Puzzle> | null>(null);

    useEffect(() => {
        const loadArchive = async (): Promise<void> => {
            const now = new Date();
            const size = boardSize * boardSize;
            const response = await fetch(`${process.env.REACT_APP_API_URL}/archive/${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}/${size}`);
            const json = await response.json();
            const newData: Array<Puzzle> = [];
            const results = JSON.parse(localStorage.getItem('results') || '[]');
            const scores = results.reduce((scores: Record<number, number>, record: ResultRecord) => {
                scores[record.p] = record.s;

                return scores;
            }, {});

            Object.keys(json).forEach(key => {
                const decoded = decodePuzzle(json[key]);

                if (scores[decoded.id]) {
                    decoded.score = scores[decoded.id];
                } else {
                    decoded.score = -2;
                }

                newData.push(decoded);
            })

            setData(newData);
        };

        loadArchive();
    }, [boardSize, decodePuzzle]);

    const handleChangePuzzle = (puzzle: Puzzle): void => {
        loadPuzzle(puzzle);
    };

    const formatDate = (date: string): string => {
        const d = new Date(date);
        const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

        return `${days[d.getDay()]} ${d.getDate()} ${months[d.getMonth()]} ${d.getFullYear()}`;
    }

    if (! data) {
        return (
            <div id="archive">
                <Loading />
            </div>
        );
    }

    return (
        <div id="archive">
            {data.map((row, key) => (
                <div key={key} className="archive-row" onClick={() => handleChangePuzzle(row)}>
                    <div className="data">
                        <span className="number">#{row.id}</span>
                        <span className="date">{formatDate(row.day)}</span>
                    </div>
                    <div className="result">
                        {row.score >= 0 && <div className="completed">
                            {[...Array(row.score).keys()].map(k => <Star key={k} className="active" />)}
                            {[...Array(3 - row.score).keys()].map(k => <Star key={k} className="inactive" />)}
                        </div>}
                        {row.score === -1 && <span className="unattempted">Unfortunate</span>}
                        {row.score === -2 && <span className="unattempted">Unattempted</span>}
                    </div>
                </div>
            ))}
        </div>
    );
}

export default Archive;
